import React from 'react';
import { payScheduleSummary, showsWhenPaidStatement, WHEN_PAID_STATEMENT } from '../utils/payScheduleDisplay';

/* PayScheduleDisplay -- the company's pay schedule, READ-ONLY (bi-weekly payroll, step 4; Brian Q7: the schedule is set in
   the onboarding wizard, there is no live edit). TEXT ONLY: no control, no handler, no request -- so there is nothing here
   for a <ViewOnly> region to grey and nothing for verify-view-only.js to gate. Every role sees it.
   `schedule` is the engine's object (payScheduleFromSettings); a company that was never asked shows "Semi-monthly" (A7).
   `accountLabel` is the linked accrued-payroll account's label (null = none linked). The words are utils/payScheduleDisplay's. */

const FONT = "'DM Sans',-apple-system,sans-serif";

export default function PayScheduleDisplay({ schedule, accountLabel = null, style }) {
  return (
    <div data-testid="pay-schedule-display" style={{
      padding: '10px 18px', borderRadius: 12, background: 'rgba(90,95,192,0.04)',
      border: '1px solid rgba(90,95,192,0.14)', fontFamily: FONT, ...style,
    }}>
      <div style={{ fontSize: 13, color: '#1A1C2E' }}>
        <span style={{ fontWeight: 700 }}>Pay schedule: </span>
        <span data-testid="pay-schedule-summary">{payScheduleSummary(schedule, accountLabel)}</span>
      </div>
      {showsWhenPaidStatement(schedule) && (
        <div data-testid="pay-schedule-when-paid" style={{ fontSize: 11, color: '#8B8FA3', marginTop: 6, lineHeight: 1.5 }}>{WHEN_PAID_STATEMENT}</div>
      )}
    </div>
  );
}
